import Login from "@stories/pages/Authenticate/Login";

export const LoginView = () => {
  return <Login />;
};
